import { FormatType } from "../../Alert/Filter/FilterType";
import {
  ConfigurationFormType,
  ConfigurationPageTables,
  ConfigurationPageType,
  ConfigurationTableFilterType,
} from "../interfaces";

export const SETUP_BUDGET_PROPERTY_MONTH_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "BUDGET_PROPERTY_MONTH",
  path: "budgets-property",
  description: "CONF_DESC_SETUP_BUDGET",
  model: {
    entityName: "uh_cat.short_name",
    label: "BUDGET",
    path: "/api/budgets/grouped",
    bulkPath: "/api/budgets/bulk-updates",
    queryParams: {
      level: "property",
      period: "month",
    },
    queryParamsUrl: {
      level: "property",
      period: "month",
    },
    name: "budget",
    attributes: [
      {
        key: "property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        align: "right",
        key: "occupation_date",
        order: 2,
        label: "DATE",
        type: FormatType.DATE,
        format: {
          month: "short",
          year: "numeric",
        },
        visible: true,
      },
      {
        align: "right",
        key: "turnover_before_tax",
        order: 3,
        label: "REVENUE_BEFORE_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "turnover_after_tax",
        order: 4,
        label: "REVENUE_AFTER_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "nb_uh",
        order: 5,
        label: "NB_UH",
        type: FormatType.NUMBER,
        maximumFractionDigits: 2,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "hebergement_nom_court",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__gte",
        label: "START_DATE",
        views: ["month", "year"],
        maxDateField: "occupation_date__lte",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__lte",
        label: "END_DATE",
        views: ["month", "year"],
        minDateField: "occupation_date__gte",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/budgets/grouped/export" },
    import: { path: "/api/budgets/grouped/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchLookup: "uh_cat__property",
      },
      {
        key: "occupation_date",
        label: "DATE",
        views: ["month", "year"],
        type: ConfigurationFormType.DatePicker,
      },
      {
        key: "turnover_before_tax",
        label: "REVENUE_BEFORE_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "turnover_after_tax",
        label: "REVENUE_AFTER_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "nb_uh",
        label: "NB_UH",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "property",
        flex: "50%",
        required: true,
      },
      {
        key: "occupation_date",
        flex: "50%",
        required: true,
      },
      {
        key: "turnover_before_tax",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    deletable: true,
    hideMassDelete: true,
    editable: true,
    editOptions: [
      {
        key: "property",
        flex: "50%",
        readonly: true,
      },
      {
        key: "occupation_date",
        flex: "50%",
        readonly: true,
      },
      {
        key: "turnover_before_tax",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "turnover_before_tax",
        flex: "50%",
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
      },
      {
        key: "nb_uh",
        flex: "50%",
      },
    ],
  },
};

export const SETUP_BUDGET_PROPERTY_DAY_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "BUDGET_PROPERTY_DAY",
  path: "budgets-property",
  description: "CONF_DESC_SETUP_BUDGET",
  model: {
    entityName: "uh_cat.short_name",
    label: "BUDGET",
    path: "/api/budgets/grouped",
    bulkPath: "/api/budgets/bulk-updates",
    queryParams: {
      level: "property",
      period: "day",
    },
    queryParamsUrl: {
      level: "property",
      period: "day",
    },
    name: "budget",
    attributes: [
      {
        key: "property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        align: "right",
        key: "occupation_date",
        order: 2,
        label: "DATE",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "turnover_before_tax",
        order: 3,
        label: "REVENUE_BEFORE_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "turnover_after_tax",
        order: 4,
        label: "REVENUE_AFTER_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "nb_uh",
        order: 5,
        label: "NB_UH",
        type: FormatType.NUMBER,
        maximumFractionDigits: 2,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "hebergement_nom_court",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__gte",
        label: "START_DATE",
        maxDateField: "occupation_date__lte",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__lte",
        label: "END_DATE",
        minDateField: "occupation_date__gte",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/budgets/grouped/export" },
    import: { path: "/api/budgets/grouped/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchLookup: "uh_cat__property",
      },
      {
        key: "occupation_date",
        label: "DATE",
        type: ConfigurationFormType.DatePicker,
      },
      {
        key: "turnover_before_tax",
        label: "REVENUE_BEFORE_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "turnover_after_tax",
        label: "REVENUE_AFTER_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "nb_uh",
        label: "NB_UH",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "property",
        flex: "50%",
        required: true,
      },
      {
        key: "occupation_date",
        flex: "50%",
        required: true,
      },
      {
        key: "turnover_before_tax",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    deletable: true,
    hideMassDelete: true,
    editable: true,
    editOptions: [
      {
        key: "property",
        flex: "50%",
        readonly: true,
      },
      {
        key: "occupation_date",
        flex: "50%",
        readonly: true,
      },
      {
        key: "turnover_before_tax",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "turnover_before_tax",
        flex: "50%",
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
      },
      {
        key: "nb_uh",
        flex: "50%",
      },
    ],
  },
};

export const SETUP_BUDGET_UHCAT_MONTH_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "BUDGET_UHCAT_MONTH",
  path: "budgets-property",
  description: "CONF_DESC_SETUP_BUDGET",
  model: {
    dynamicPath: true,
    entityName: "uh_cat.short_name",
    label: "BUDGET",
    path: "/api/budgets/grouped",
    bulkPath: "/api/budgets/bulk-updates",
    queryParams: {
      level: "uh_cat",
      period: "month",
    },
    queryParamsUrl: {
      level: "uh_cat",
      period: "month",
    },
    name: "budget",
    attributes: [
      {
        key: "property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 2,
        label: "UH_CAT",
        visible: true,
      },
      {
        align: "right",
        key: "occupation_date",
        order: 3,
        label: "DATE",
        type: FormatType.DATE,
        format: {
          month: "short",
          year: "numeric",
        },
        visible: true,
      },
      {
        align: "right",
        key: "turnover_before_tax",
        order: 4,
        label: "REVENUE_BEFORE_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "turnover_after_tax",
        order: 5,
        label: "REVENUE_AFTER_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "nb_uh",
        order: 6,
        label: "NB_UH",
        type: FormatType.NUMBER,
        maximumFractionDigits: 2,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "name",
        },
        key: "uh_cat",
        labelKey: "name",
        label: "UH_CAT",
        lookup: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__gte",
        label: "START_DATE",
        views: ["month", "year"],
        maxDateField: "occupation_date__lte",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__lte",
        label: "END_DATE",
        views: ["month", "year"],
        minDateField: "occupation_date__gte",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/budgets/grouped/export" },
    import: { path: "/api/budgets/grouped/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchedBy: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          property: {
            path: "property.id",
          },
        },
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        watchField: [
          {
            paramsKey: "property",
            paramsValue: "id",
            watchFieldPath: "property",
          },
        ],
      },
      {
        key: "occupation_date",
        label: "DATE",
        views: ["month", "year"],
        type: ConfigurationFormType.DatePicker,
      },
      {
        key: "turnover_before_tax",
        label: "REVENUE_BEFORE_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "turnover_after_tax",
        label: "REVENUE_AFTER_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        key: "nb_uh",
        label: "NB_UH",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "property",
        flex: "50%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "occupation_date",
        flex: "50%",
        required: true,
      },
      {
        key: "turnover_before_tax",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    deletable: true,
    hideMassDelete: true,
    editable: true,
    editOptions: [
      {
        key: "property",
        flex: "50%",
        readonly: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        readonly: true,
      },
      {
        key: "occupation_date",
        flex: "50%",
        readonly: true,
      },
      {
        key: "turnover_before_tax",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "turnover_before_tax",
        flex: "50%",
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
      },
      {
        key: "nb_uh",
        flex: "50%",
      },
    ],
  },
};

export const SETUP_BUDGET_UHCAT_DAY_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "BUDGET_UHCAT_DAY",
  path: "budgets-uhcat",
  description: "CONF_DESC_SETUP_BUDGET",
  separator: true,
  model: {
    dynamicPath: true,
    entityName: "uh_cat.short_name",
    label: "BUDGET",
    path: "/api/budgets",
    bulkPath: "/api/budgets/bulk-updates",
    queryParams: {
      level: "uh_cat",
      period: "day",
    },
    queryParamsUrl: {
      level: "uh_cat",
      period: "day",
    },
    name: "budget",
    attributes: [
      {
        key: "uh_cat.property.hebergement_nom_court",
        order: 1,
        label: "PROPERTY",
        visible: true,
      },
      {
        key: "uh_cat.short_name",
        order: 2,
        label: "UH_CAT",
        visible: true,
      },
      {
        align: "right",
        key: "occupation_date",
        order: 3,
        label: "DATE",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "turnover_before_tax",
        order: 4,
        label: "REVENUE_BEFORE_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "turnover_after_tax",
        order: 5,
        label: "REVENUE_AFTER_TAX",
        type: FormatType.NUMBER,
        maximumFractionDigits: 0,
        visible: true,
      },
      {
        align: "right",
        key: "nb_uh",
        order: 6,
        label: "NB_UH",
        type: FormatType.NUMBER,
        maximumFractionDigits: 2,
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "property",
        labelKey: "hebergement_nom_court",
        label: "PROPERTY",
        lookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "name",
        },
        key: "uh_cat",
        labelKey: "name",
        label: "UH_CAT",
        lookup: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__gte",
        label: "START_DATE",
        maxDateField: "occupation_date__lte",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "occupation_date__lte",
        label: "END_DATE",
        minDateField: "occupation_date__gte",
      },
      {
        type: ConfigurationTableFilterType.Search,
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/budgets/export" },
    import: { path: "/api/budgets/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/properties/",
        apiParams: {
          page_size: 100,
          ordering: "hebergement_nom_court",
        },
        key: "uh_cat.property",
        label: "PROPERTY",
        labelKey: "hebergement_nom_court",
        watchedBy: "uh_cat",
        watchLookup: "uh_cat__property",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/uh-cats/",
        apiParams: {
          page_size: 100,
          ordering: "short_name",
          property: {
            path: "uh_cat.property.id",
          },
        },
        key: "uh_cat",
        label: "UH_CAT",
        labelKey: "short_name",
        watchField: [
          {
            paramsKey: "property",
            paramsValue: "id",
            watchFieldPath: "uh_cat.property",
          },
        ],
      },
      {
        key: "occupation_date",
        label: "DATE",
        type: ConfigurationFormType.DatePicker,
      },
      {
        inputType: "number",
        key: "turnover_before_tax",
        label: "REVENUE_BEFORE_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "number",
        key: "turnover_after_tax",
        label: "REVENUE_AFTER_TAX",
        type: ConfigurationFormType.Input,
      },
      {
        inputType: "number",
        key: "nb_uh",
        label: "NB_UH",
        type: ConfigurationFormType.Input,
      },
    ],
    copyable: false,
    creatable: true,
    createOptions: [
      {
        key: "uh_cat.property",
        flex: "50%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "occupation_date",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_before_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    deletable: true,
    hideMassDelete: true,
    editable: true,
    editOptions: [
      {
        key: "uh_cat.property",
        flex: "50%",
        required: true,
      },
      {
        key: "uh_cat",
        flex: "50%",
        required: true,
      },
      {
        key: "occupation_date",
        flex: "100%",
        required: true,
      },
      {
        key: "turnover_before_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
        required: true,
      },
      {
        key: "nb_uh",
        flex: "50%",
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "turnover_before_tax",
        flex: "50%",
      },
      {
        key: "turnover_after_tax",
        flex: "50%",
      },
      {
        key: "nb_uh",
        flex: "50%",
      },
    ],
  },
};

export const SETUP_CURRENCY_CONVERSION_TAB: ConfigurationPageTables = {
  type: ConfigurationPageType.TABLE,
  label: "CONFIG.FINANCE.CURRENCIES.CURRENCY_CONVERSION_RATES",
  path: "currency-conversion-rates",
  description: "CONFIG.FINANCE.CURRENCIES.DESC_SETUP_CURRENCY_CONVERSION",
  model: {
    dynamicPath: true,
    entityName: "from_currency.code",
    path: "/api/currency-conversion-rates",
    bulkPath: "/api/currency-conversion-rates/bulk-updates",
    label: "CONFIG.FINANCE.CURRENCIES.CURRENCY_CONVERSION_RATES_MODEL",
    name: "currencyConversionRate",
    attributes: [
      {
        key: "from_currency.code",
        order: 1,
        label: "CONFIG.FINANCE.CURRENCIES.FROM_CURRENCY",
        visible: true,
      },
      {
        key: "to_currency.code",
        order: 2,
        label: "CONFIG.FINANCE.CURRENCIES.TO_CURRENCY",
        visible: true,
      },
      {
        align: "right",
        key: "start_date_included",
        order: 3,
        label: "CONFIG.FINANCE.CURRENCIES.START_DATE",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "end_date_excluded",
        order: 4,
        label: "CONFIG.FINANCE.CURRENCIES.END_DATE_EXCLUDED",
        type: FormatType.DATE,
        visible: true,
      },
      {
        align: "right",
        key: "rate",
        order: 5,
        label: "CONFIG.FINANCE.CURRENCIES.RATE",
        type: FormatType.NUMBER,
        maximumFractionDigits: 8, // Match model's decimal_places
        visible: true,
      },
    ],
    filters: [
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/currencies/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "from_currency",
        labelKey: "code",
        lookup: "from_currency", // currency id , I wish I could use the code instead
        label: "CONFIG.FINANCE.CURRENCIES.FROM_CURRENCY",
      },
      {
        type: ConfigurationTableFilterType.Select,
        api: "/api/currencies/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "to_currency",
        labelKey: "code",
        lookup: "to_currency", // currency id , I wish I could use the code instead
        label: "CONFIG.FINANCE.CURRENCIES.TO_CURRENCY",
      },
      {
        type: ConfigurationTableFilterType.DatePicker,
        lookup: "active_date",
        label: "CONFIG.FINANCE.CURRENCIES.ACTIVE_ON_DATE",
      },
      {
        type: ConfigurationTableFilterType.ResetButton,
      },
    ],
    export: { path: "/api/currency-conversion-rates/export" },
    // import: { path: "/api/currency-conversion-rates/presign-url" },
  },
  options: {
    formFields: [
      {
        type: ConfigurationFormType.Select,
        api: "/api/currencies/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "from_currency",
        label: "CONFIG.FINANCE.CURRENCIES.FROM_CURRENCY",
        labelKey: "code",
        watchLookup: "from_currency__code",
        dataKey: "label",
      },
      {
        type: ConfigurationFormType.Select,
        api: "/api/currencies/",
        apiParams: {
          page_size: 100,
          ordering: "code",
        },
        key: "to_currency",
        label: "CONFIG.FINANCE.CURRENCIES.TO_CURRENCY",
        labelKey: "code",
        watchLookup: "to_currency__code",
        dataKey: "label",
      },
      {
        key: "start_date_included",
        label: "CONFIG.FINANCE.CURRENCIES.START_DATE",
        type: ConfigurationFormType.DatePicker,
      },
      {
        key: "end_date_excluded",
        label: "CONFIG.FINANCE.CURRENCIES.END_DATE_EXCLUDED",
        type: ConfigurationFormType.DatePicker,
      },
      {
        inputType: "number",
        key: "rate",
        label: "CONFIG.FINANCE.CURRENCIES.RATE",
        type: ConfigurationFormType.Input,
        // step: "0.00000001", // Allow high precision
      },
    ],
    copyable: false, // You can't copy, as the PK fields (dates, currencies) are unique
    creatable: true,
    createOptions: [
      {
        key: "from_currency",
        flex: "50%",
        required: true,
      },
      {
        key: "to_currency",
        flex: "50%",
        required: true,
      },
      {
        key: "start_date_included",
        flex: "50%",
        required: true,
      },
      {
        key: "end_date_excluded",
        flex: "50%",
        required: true,
      },
      {
        key: "rate",
        flex: "100%",
        required: true,
      },
    ],
    deletable: true,
    hideMassDelete: false, // Allow mass deletion of old rates
    editable: true,
    editOptions: [
      {
        key: "from_currency",
        flex: "50%",
        required: true,
      },
      {
        key: "to_currency",
        flex: "50%",
        required: true,
      },
      {
        key: "start_date_included",
        flex: "50%",
        required: true,
      },
      {
        key: "end_date_excluded",
        flex: "50%",
        required: true,
      },
      {
        key: "rate",
        flex: "100%",
        required: true,
      },
    ],
    editSelectedOptions: [
      {
        key: "rate",
        flex: "100%",
      },
    ],
  },
};

export const SETUP_BUDGET_PAGE = {
  type: ConfigurationPageType.TABS,
  count: 0,
  label: "BUDGET",
  pageLabel: "BUDGET_TITLE_SETUP",
  pageDescription: "BUDGET_TITLE_SETUP_EXPLANATIONS",
  menuLabel: "BUDGET",
  name: "Budget",
  path: "budget",
  tabs: [
    SETUP_BUDGET_PROPERTY_MONTH_TAB,
    SETUP_BUDGET_PROPERTY_DAY_TAB,
    SETUP_BUDGET_UHCAT_MONTH_TAB,
    SETUP_BUDGET_UHCAT_DAY_TAB,
    SETUP_CURRENCY_CONVERSION_TAB,
  ],
};
